module.exports = __webpack_public_path__ + "media/images/athletes/1659-e33aec0b4dd092c1d6831e7cbdc6d130.png";